export function defaultX(d) {
  return d[0];
}

export default function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/x.js
// module id = 1125
// module chunks = 4